import React, { useEffect, useState } from 'react';

export default function AccessDenied() {

    return (
        <main className="min-h-screen flex flex-col items-center justify-center p-6"
            style={{ background: 'linear-gradient(160deg, #fce8f3 0%, #fdf4f9 50%, #f8e8f5 100%)' }}>

            {/* 18+ */}
            <div className="mb-8 relative">
                <p className="text-[120px] font-bold leading-none tracking-tighter text-[#AF0056]/10 select-none">
                    18+
                </p>
                <div className="absolute inset-0 flex items-center justify-center">
                    <p className="text-[120px] font-bold leading-none tracking-tighter text-transparent select-none"
                        style={{ WebkitTextStroke: '2px rgba(175,0,86,0.25)' }}>
                        18+
                    </p>
                </div>
            </div>

            <p className="text-sm font-medium text-[#AF0056] tracking-widest uppercase mb-4">
                Access denied
            </p>

            <h1 className="text-4xl font-bold text-gray-900 mb-5 text-center leading-tight">
                TLK is only available<br />to adults 18 and older.
            </h1>

        </main>
    );
}